import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { initMetaPixel } from './utils/metaPixel';
import { META } from './data/soklar';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { HowItWorks } from './components/HowItWorks';
import { Audience } from './components/Audience';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
function setMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}
export function App() {
  useEffect(() => {
    initMetaPixel();
    document.documentElement.lang = 'sv';
    document.title = META.title;
    setMeta('name', 'description', META.description);
    setMeta('property', 'og:title', META.ogTitle);
    setMeta('property', 'og:description', META.ogDescription);
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:locale', 'sv_SE');
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3dl4mds74frxz">
      <div lang="sv" className="w-full bg-stone-50 font-sans text-slate-900 antialiased" data-id="element-1" data-mp="3dm60k5jfoujx">
        <CountdownBar data-id="element-2" data-mp="nv0x5qhcgk43" />
        <main data-id="element-3" data-mp="nxwwnj8ubgun">
          <Hero data-id="element-4" data-mp="sunf2d84aoj8" />
          <StatsBar data-id="element-5" data-mp="su42lc18kscl" />
          <Difference data-id="element-6" data-mp="stc9c7v436ph" />
          <Recognize data-id="element-7" data-mp="ssss6tdacmci" />
          <WhatsInside data-id="element-8" data-mp="36hwt7ylgu1r" />
          <InsidePages data-id="element-9" data-mp="35ynugqx9fzv" />
          <Bonuses data-id="element-10" data-mp="356sn718lka4" />
          <HowItWorks data-id="element-11" data-mp="34nbvtnbp1xo" />
          <Audience data-id="element-12" data-mp="38b2ol1dva8p" />
          <Offer data-id="element-13" data-mp="3udavo55x0h34" />
          <Guarantee data-id="element-14" data-mp="3ubrg6gs32a2e" />
          <Testimonials data-id="element-15" data-mp="3uc9i9u1ffii8" />
          <Faq data-id="element-16" data-mp="3uf5hrmsxaf8s" />
          <FinalCta data-id="element-17" data-mp="d4e6dvbvvgxr" />
        </main>
        <Footer data-id="element-18" data-mp="d3mil6oj2ni1" />
      </div>
    </MotionConfig>;
}